export interface AuthData {
  access_token: string;
  refresh_token: string;
}

export function getWebStorefrontScreen(screens: any[]) {
  return screens.find((screen) => screen.type === 'web-storefront');
}

export const PAYMENT_PROVIDER_CLEENG = 'Cleeng';
export const PAYMENT_PROVIDER_STRIPE = 'stripe';
export const PAYMENT_PROVIDER_INPLAYER = 'inplayer';
export const PAYMENT_PROVIDER_ZYPE = 'zype';
export const PAYMENT_PROVIDER_BRIGHTCOVE = 'brightcove';
export const CLEENG_LOCAL_STORAGE_TEXT = 'CLEENG';

export const POLLING_VALIDATION_NUMBER_OF_RETRIES = 10;
export const POLLING_VALIDATION_INTERVAL = 2_000;
export const CLEENG_POLLING_VALIDATION_INTERVAL = 10_000;
